module.exports = __webpack_public_path__ + "media/images/v1/author-8a21122262177158ec9cb07eae6be11d.png";